import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ApiUrl from '../../utils/config';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      await axios.post(`${ApiUrl}/api/Auth/forgot-password`, { email });
      setMessage('Если аккаунт с таким email существует, на него отправлен новый пароль. Проверьте почту (и папку «Спам»).');
      setEmail('');
    } catch (err: unknown) {
      const msg = axios.isAxiosError(err) && err.response?.data?.message
        ? err.response.data.message
        : 'Произошла ошибка. Попробуйте позже.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page auth-page">
      <h2>Восстановление пароля</h2>
      <p className="auth-page__hint">Укажите email вашего аккаунта. Мы отправим на него новый пароль для входа.</p>
      {error && <div className="error-message auth-page__error">{error}</div>}
      {message && <div className="auth-page__success">{message}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn" disabled={loading}>
            {loading ? 'Отправка…' : 'Отправить новый пароль'}
          </button>
        </div>
      </form>

      <div className="register-link auth-page__register-link">
        <p><Link to="/login">Вернуться к входу</Link></p>
      </div>
    </div>
  );
};

export default ForgotPassword;
